var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar-x'),_c('div',{staticClass:"module"},[_c('navbar-y'),_c('titlebar'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.path})],1),_c('message',{directives:[{name:"show",rawName:"v-show",value:(_vm.messages),expression:"messages"}]})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }